// Estado global para controlar a abertura do menu/modal de cashback
const shouldOpenCashback = ref(false);

export const useCashbackMenu = () => {
  const route = useRoute();
  const router = useRouter();

  // Abre o menu/modal de cashback
  function openCashbackMenu() {
    shouldOpenCashback.value = true;
  }

  // Reseta o estado após consumir
  function consumeOpenRequest(): boolean {
    if (shouldOpenCashback.value) {
      shouldOpenCashback.value = false;

      return true;
    }

    return false;
  }

  // Apenas verifica se tem o param na URL (não modifica nada)
  function hasRouteParam(): boolean {
    const q = route.query?.open;
    const openParam = Array.isArray(q) ? q[0] : q;
    const hash = route.hash || '';

    return openParam === 'cashback' || hash === '#cashback';
  }

  // Verifica param e seta estado + limpa URL (chamar apenas uma vez)
  function handleRouteParam(): boolean {
    if (hasRouteParam()) {
      openCashbackMenu();

      // Remove o param da URL
      const { open, ...rest } = route.query as Record<string, any>;

      router
        .replace({ path: route.path, query: rest, hash: '' })
        .catch(() => {});

      return true;
    }

    return false;
  }

  return {
    shouldOpenCashback: computed(() => shouldOpenCashback.value),
    openCashbackMenu,
    consumeOpenRequest,
    hasRouteParam,
    handleRouteParam,
  };
};
